export function scanResponseToBlob(data: any): Blob | null {
    if (data instanceof Blob) return data;
    if (data instanceof ArrayBuffer) return new Blob([data], { type: 'application/pdf' });
    if (Array.isArray(data)) return new Blob([new Uint8Array(data)], { type: 'application/pdf' });
    if (typeof data === 'string') {
        try {
            const binaryString = atob(data);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return new Blob([bytes], { type: 'application/pdf' });
        } catch {
            return null;
        }
    }
    return null;
}
